<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

const host = ref(null);
const loadError = ref('');

const waitForStoreAdmin = () =>
  new Promise(resolve => {
    if (window.TGCSStoreAdmin?.mount) {
      resolve(window.TGCSStoreAdmin);
      return;
    }

    let attempts = 0;
    let timerId = null;
    let cleanup = () => {};
    const handleReady = () => {
      if (!window.TGCSStoreAdmin?.mount) return;
      cleanup();
      resolve(window.TGCSStoreAdmin);
    };
    cleanup = () => {
      if (timerId) window.clearInterval(timerId);
      window.removeEventListener('tgcs-store-admin-ready', handleReady);
    };

    window.addEventListener('tgcs-store-admin-ready', handleReady);
    timerId = window.setInterval(() => {
      attempts += 1;
      if (window.TGCSStoreAdmin?.mount) {
        handleReady();
      } else if (attempts >= 80) {
        cleanup();
        resolve(null);
      }
    }, 100);
  });

onMounted(async () => {
  await nextTick();
  const storeAdmin = await waitForStoreAdmin();
  if (!storeAdmin?.mount) {
    loadError.value = '店铺信息组件加载失败，请刷新 Chatwoot 后重试。';
    return;
  }
  storeAdmin.mount(host.value);
});

onBeforeUnmount(() => {
  window.TGCSStoreAdmin?.unmount?.();
});
</script>

<template>
  <section
    class="flex flex-col flex-1 min-w-0 h-full overflow-hidden bg-n-surface-1"
  >
    <div
      id="tgcs-store-admin-native-host"
      ref="host"
      class="w-full h-full overflow-auto"
    />
    <p
      v-if="loadError"
      class="m-6 rounded-lg border border-n-ruby-5 bg-n-ruby-2 px-4 py-3 text-sm text-n-ruby-11"
    >
      {{ loadError }}
    </p>
  </section>
</template>
